import StorageIcon from "@mui/icons-material/Storage";
import ArticleIcon from "@mui/icons-material/Article";
import SecurityIcon from "@mui/icons-material/Security";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

export const tabs = [
  { label: 'Schema Generation', icon: StorageIcon, route: 'schema' },
  { label: 'Page Builder', icon: ArticleIcon, route: 'pagebuilder' },
  { label: 'Roles & Permissions', icon: SecurityIcon, route: 'roles' },
  { label: 'Workflow Automation', icon: AutoAwesomeIcon, route: 'workflow' },
  { label: 'Deploy & Test', icon: RocketLaunchIcon, route: 'deploy' }
];

export const dynamicMenus = tabs.map((tab) => ({
  menuName: tab.label,
  icon: tab.icon,
  route: tab.route
}));
